const buildEmptyAddress = () => {
  return {
    street: "",
    suburb: "",
    state: "",
    postcode: "",
    address_type: "",
    address_amount: "",
    other_text: "",
    moved_in: {
      day: "",
      month: "",
      year: "",
    },
  };
};

const buildEmptyPreviousAddress = (index) => {
  return {
    variable: index,
    street: "",
    suburb: "",
    state: "",
    postcode: "",
    address_type: "",
    address_amount: "",
    other_text: "",
    moved_in: {
      day: "",
      month: "",
      year: "",
    },
    moved_out: {
      day: "",
      month: "",
      year: "",
    },
  };
};

const ensureAddressShape = (address = {}) => {
  const nextAddress = {
    ...buildEmptyAddress(),
    ...address,
  };

  nextAddress.moved_in = {
    day: "",
    month: "",
    year: "",
    ...(address.moved_in || {}),
  };

  return nextAddress;
};

const ensurePreviousAddressShape = (address = {}, index = 1) => {
  const nextAddress = {
    ...buildEmptyPreviousAddress(index),
    ...address,
  };

  nextAddress.moved_in = {
    day: "",
    month: "",
    year: "",
    ...(address.moved_in || {}),
  };

  nextAddress.moved_out = {
    day: "",
    month: "",
    year: "",
    ...(address.moved_out || {}),
  };

  return nextAddress;
};

export const normalizeAddressDetails = (rawSection = {}) => {
  const normalized = {
    applicants: {},
    applicant_order: [],
  };

  if (rawSection && rawSection.applicants && Object.keys(rawSection.applicants).length > 0) {
    const applicantOrder = Array.isArray(rawSection.applicant_order)
      ? rawSection.applicant_order.filter((id) => rawSection.applicants[id] !== undefined)
      : Object.keys(rawSection.applicants);

    applicantOrder.forEach((id) => {
      normalized.applicants[id] = normalizeApplicantAddress(rawSection.applicants[id]);
    });
    normalized.applicant_order = applicantOrder;
  } else {
    const legacyApplicantKeys = Object.keys(rawSection || {}).filter((key) =>
      /^applicant\d+$/i.test(key)
    );

    legacyApplicantKeys.forEach((key) => {
      normalized.applicants[key] = normalizeApplicantAddress(rawSection[key]);
      normalized.applicant_order.push(key);
    });
  }

  if (normalized.applicant_order.length === 0) {
    normalized.applicant_order = ["applicant1"];
    normalized.applicants.applicant1 = {
      current: buildEmptyAddress(),
      previous: [],
    };
  }

  return normalized;
};

const normalizeApplicantAddress = (rawApplicant = {}) => {
  const applicantAddress = {
    current: ensureAddressShape(rawApplicant),
    previous: [],
  };

  const previousAddressKeys = Object.keys(rawApplicant)
    .filter((key) => key.startsWith("previousaddress"))
    .sort((a, b) => {
      const aNum = parseInt(a.replace("previousaddress_", ""));
      const bNum = parseInt(b.replace("previousaddress_", ""));
      return aNum - bNum;
    });

  previousAddressKeys.forEach((key, index) => {
    applicantAddress.previous.push(ensurePreviousAddressShape(rawApplicant[key], index + 1));
  });

  return applicantAddress;
};

export const buildPersistedAddressDetails = (normalizedSection) => {
  const persisted = {
    applicants: {},
    applicant_order: [...(normalizedSection.applicant_order || [])],
  };

  (normalizedSection.applicant_order || []).forEach((id, index) => {
    const applicantData = normalizedSection.applicants[id];
    const persistedApplicant = {
      ...ensureAddressShape(applicantData.current),
    };

    applicantData.previous.forEach((prevAddress, prevIndex) => {
      const key = `previousaddress_${prevIndex + 1}`;
      persistedApplicant[key] = ensurePreviousAddressShape(prevAddress, prevIndex + 1);
    });

    persisted.applicants[id] = persistedApplicant;
    persisted[`applicant${index + 1}`] = persistedApplicant;
  });

  if (!persisted.applicant1) {
    persisted.applicant1 = {
      ...buildEmptyAddress(),
    };
  }

  return persisted;
};

export const validateAddressHistory = (applicantAddress, requiredYearsBack = 3) => {
  const targetYear = new Date().getFullYear() - (requiredYearsBack - 1);
  
  if (applicantAddress.current.moved_in && applicantAddress.current.moved_in.year) {
    const movedInYear = parseInt(applicantAddress.current.moved_in.year);
    if (movedInYear <= targetYear) {
      return true;
    }
  }

  for (const prevAddress of applicantAddress.previous) {
    if (prevAddress.moved_in && prevAddress.moved_in.year) {
      const movedInYear = parseInt(prevAddress.moved_in.year);
      if (movedInYear <= targetYear) {
        return true;
      }
    }
  }

  return false;
};
